import { OptionProperty } from '../../../../form/controls/components/select/enums';

export const PAGINATION_ITEMS_PER_PAGE_OPTIONS = [5, 10, 25, 50, 100]
  .map((itemsPerPage) => ({
    [OptionProperty.Value]: itemsPerPage,
    [OptionProperty.Label]: itemsPerPage,
  }));

export const DEFAULT_ACTIVE_PAGE = 1;

export const DEFAULT_ITEMS_PER_PAGE = PAGINATION_ITEMS_PER_PAGE_OPTIONS[0].value;
